import { LoginpageComponent } from './components/login-page/login-page.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ResetMailComponent } from './components/reset-mail/reset-mail.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { CodeResetComponent } from './components/code-reset/code-reset.component';
import { RegisterComponent } from './components/register/register.component';
import { CodeVerificationComponent } from './components/code-verification/code-verification.component';
import { LoginintervenantComponent } from './components/login-intervenant/loginintervenant/loginintervenant.component';
import { InitPasswordComponent } from './components/init-password/init-password.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginpageComponent,
  },
  {
    path: 'loginintervenant',
    component: LoginintervenantComponent,
  },
  {
    path: 'reset-mail',
    component: ResetMailComponent,
  },
  {
    path: 'code-reset',
    component: CodeResetComponent,
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'init',
    component: InitPasswordComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'code-verification',
    component: CodeVerificationComponent,
  },
];
@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
})
export class AuthRoutingModule {}
